import React from 'react';
import { Plus } from 'lucide-react';
import JobCard from './JobCard';

const JobSection = ({ jobs, customer, user, loadingJobs, onAddJob, onAddContract, onJobSelect, onViewInvoice, docRefreshKey }) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900">
          Jobs
          <span className="ml-2 bg-pest-blue text-white px-2 py-0.5 rounded-full text-sm font-normal">
            {jobs.length}
          </span>
        </h2>
        <div className="flex gap-2">
          <button
            onClick={() => onAddJob()}
            className="btn btn-md btn-secondary"
          >
            <Plus size={15} />
            <span>Add Job</span>
          </button>
          <button
            onClick={() => onAddContract()}
            className="btn btn-md btn-secondary"
          >
            <Plus size={15} />
            <span>Add Contract</span>
          </button>
        </div>
      </div>

      {loadingJobs ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-pest-blue mx-auto"></div>
          <p className="text-gray-400 mt-3 text-sm">Loading jobs...</p>
        </div>
      ) : jobs.length === 0 ? (
        <div className="text-center py-8 bg-white rounded-lg border-2 border-dashed border-gray-200">
          <p className="text-gray-500">No jobs for this customer</p>
        </div>
      ) : (
        <div className="space-y-3">
          {jobs.map(job => (
            <JobCard
              key={job.id}
              job={job}
              customer={customer}
              user={user}
              onJobSelect={onJobSelect}
              onViewInvoice={onViewInvoice}
              refreshKey={docRefreshKey}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default JobSection;
